import { render, staticRenderFns } from "./PartnersKeysCreate.vue?vue&type=template&id=042cdbeb&"
import script from "./PartnersKeysCreate.vue?vue&type=script&lang=js&"
export * from "./PartnersKeysCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports